import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box, CssBaseline, useMediaQuery, useTheme } from '@mui/material';
import Sidebar from './Sidebar';

const PageWrapper = () => {
	const theme = useTheme();
	const isCompact = useMediaQuery(theme.breakpoints.down('md')); // md'den küçük ekranlarda compact sidebar
	const isTabletScreen = useMediaQuery('(min-width:600px) and (max-width:1199px)');
	const sidebarWidth = isCompact ? 64 : 250;

	return (
		<Box sx={{ display: 'flex' }}>
			<CssBaseline />
			<Sidebar />
			<Box 
				component="main" 
				sx={{ 
					flexGrow: 1, 
					p: isTabletScreen ? 1 : (isCompact ? 2 : 3), // Tablet'te daha az padding
					marginLeft: `${sidebarWidth}px`,
					width: `calc(100% - ${sidebarWidth}px)`,
					minHeight: '100vh',
					transition: 'margin-left 0.3s ease, width 0.3s ease',
					maxWidth: '100vw', // Viewport genişliğini aşmasın
					overflow: 'hidden' // Yatay scroll'u engelle
				}}
			>
				<Outlet />
			</Box>
		</Box>
	);
};

export default PageWrapper;